/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ModelGetTableListRequest,
  ModelGetTableListResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class TableList<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description get table list
   *
   * @tags table
   * @name TableListCreate
   * @summary get table list
   * @request POST:/tableList
   */
  tableListCreate = (
    request: ModelGetTableListRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelGetTableListResponse, any>({
      path: `/tableList`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
